import { render, staticRenderFns } from "./MakerGameItem.vue?vue&type=template&id=43d88060&scoped=true"
import script from "./MakerGameItem.vue?vue&type=script&lang=js"
export * from "./MakerGameItem.vue?vue&type=script&lang=js"
import style0 from "./MakerGameItem.vue?vue&type=style&index=0&id=43d88060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d88060",
  null
  
)

export default component.exports